<script setup lang="ts">
defineOptions({
  name: 'AssessmentContainer'
})

</script>

<template>
  <div class="assessment-container">
    <div
      v-if="$slots.default"
      class="assessment-container__box"
    >
      <slot />
    </div>
    <div
      v-if="$slots.bottom"
      class="assessment-container__bottom"
    >
      <slot name="bottom" />
    </div>
  </div>
</template>

<style lang="scss" src="@scss/layouts/AssessmentContainer.scss" />
